import { createContext } from 'react';

import noop from 'lodash/noop';

export const GridWidgetsContext = createContext({
  dragInfo: null,
  stateWidgets: null,
  widgetPositions: null,
  rowPositions: null,
  temporaryWidgetPositions: null,
  temporaryRowPositions: null,
  boardHeight: 0,
  widgetSizes: {},
  onMouseDownDrag: noop,
  onResizeBoardWidth: noop,
  onResizeWidgetHeight: noop,
});
